const PropertyType = {
	APPLICATION: 'application',
	COMPANY: 'company'
};

export default PropertyType;
